import { EmojiAdd20Regular } from '@/components/Icon'
import Tooltip from '@/components/Tooltip'
import styles from './index.module.scss'

export default function UserChatBubbleAddReactionButton({
  reactionPickerAnchorEl,
  setReactionPickerAnchorEl,
  setMoreMenuAnchor,
}) {
  return (
    <Tooltip text="Add reaction" placement="top">
      <button
        type="button"
        className={styles.reactionAddPill}
        aria-label="Add reaction"
        aria-haspopup="dialog"
        aria-expanded={Boolean(reactionPickerAnchorEl)}
        onClick={(event) => {
          event.stopPropagation()
          setMoreMenuAnchor(null)
          const t = event.currentTarget
          setReactionPickerAnchorEl((prev) => (prev === t ? null : t))
        }}
      >
        <EmojiAdd20Regular aria-hidden />
      </button>
    </Tooltip>
  )
}
